export const CODE_CLIENT_ID = 'clientID';
export const CODE_LANG = 'lang';
export const CODE_GAMEPAD_URL = 'gamepad';
// Socket server token in the gamepad URL ('v2' = Node.js server). The screen
// and the gamepads MUST join the same server, so the screen propagates its
// choice through the QR code URL.
export const CODE_SOCKET_SERVER = 'srv';

export const getScreenURL = (host: string) => `${host}/app`;
export const getSessionURL = (
    host: string,
    sessionID: number | string,
    clientID: string,
    lang: string,
    socketServer?: string
) =>
    `${host}/${CODE_GAMEPAD_URL}/${sessionID}?${CODE_CLIENT_ID}=${clientID}&${CODE_LANG}=${lang}` +
    (socketServer ? `&${CODE_SOCKET_SERVER}=${socketServer}` : '');
export const getAdventurerURL = (seed: string) =>
    `https://api.dicebear.com/5.x/adventurer/png?seed=${seed}&backgroundColor=transparent`;
